import { ValueUtil } from "./ValueUtil";
export var ObjectUtil;
(function (ObjectUtil) {
    function removeByKey(object, removeKey) {
        const resultObject = {};
        for (let key in object) {
            console.log({ key, removeKey });
            if (key === removeKey) {
                continue;
            }
            const value = object[key];
            resultObject[key] = value;
        }
        return resultObject;
    }
    ObjectUtil.removeByKey = removeByKey;
    function deepCopy(object) {
        const type = typeof object;
        if (object == null) {
            return null;
        }
        else if (type === 'object') {
            if (Array.isArray(object)) {
                const copiedArray = [];
                for (let value of object) {
                    copiedArray.push(deepCopy(value));
                }
                return copiedArray;
            }
            else {
                const copiedObject = {};
                for (let key in object) {
                    const value = object[key];
                    copiedObject[key] = deepCopy(value);
                }
                return copiedObject;
            }
        }
        else {
            return object;
        }
    }
    ObjectUtil.deepCopy = deepCopy;
    /**
     * オブジェクト(KeyValue)として値がひとつでも違っている場合は true
     * @param valueMap1
     * @param valueMap2
     * @param keyArray
     */
    function isChangeValue(valueMap1, valueMap2, keyArray) {
        for (let key of keyArray) {
            if (ValueUtil.isChange(valueMap1[key], valueMap2[key])) {
                return true;
            }
        }
        return false;
    }
    ObjectUtil.isChangeValue = isChangeValue;
    /**
     * fromMap から toMap に Key を元に Value をコピー
     * @param fromMap
     * @param toMap
     * @param keyName
     * @param doCastNumber
     */
    function copyKeyValue(fromMap, toMap, keyName, doCastNumber = false) {
        let srcValue = fromMap[keyName];
        if (ValueUtil.isEmpty(srcValue)) {
            return;
        }
        if (doCastNumber) {
            srcValue = Number(srcValue);
        }
        toMap[keyName] = srcValue;
    }
    ObjectUtil.copyKeyValue = copyKeyValue;
})(ObjectUtil || (ObjectUtil = {}));
